module.exports = __webpack_public_path__ + "img/whatsapp-checkout-1.ede6fcc0.svg";